import { Component, Input } from "@angular/core";

@Component({
  selector: "app-save-icon",
  standalone: true,
  imports: [],
  templateUrl: "./save-icon.component.html",
  styleUrl: "./save-icon.component.scss",
})
export class SaveIconComponent {
  @Input() isSaved: boolean = false;
  @Input() isSaving: boolean = false;
  @Input() error: boolean = false;
}
